// import React from "react";
import EditorReadOnly from '../rich-text-editor/index.js';

const RichTextRenderer = ({ data, additionalClassName = ``, additionalClassNameEditor = `` }) => {
	if (data) {
		// Notifications with new format data

		// Check if the data is already parsed because of a previous parser
		if (
			typeof data === 'object' &&
			Object.hasOwn(data, 'editorState') &&
			Object.hasOwn(data, 'plainText') &&
			Object.hasOwn(data, 'text')
		) {
			if (data?.plainText && data?.editorState) {
				return (
					<EditorReadOnly preLoadedState={data.editorState} additionalClassName={additionalClassNameEditor} />
				);
			}

			// Content is PLAIN TEXT
			if (data?.text && data?.text.trim() !== '') {
				return <div className={additionalClassName}>{data.text}</div>;
			}
		}

		// If not parsed, we assume the data is a JSON string
		// and we try to parse it
		try {
			// If we can parse the data, the data is already in object form
			const parsedData = JSON.parse(data);

			// Content is RICH TEXT
			if (parsedData?.plainText && parsedData?.editorState) {
				return (
					<EditorReadOnly
						preLoadedState={parsedData.editorState}
						additionalClassName={additionalClassNameEditor}
					/>
				);
			}

			// Content is PLAIN TEXT
			if (parsedData?.text && parsedData?.text.trim() !== '') {
				return <div className={additionalClassName}>{parsedData.text}</div>;
			}

			return null;
		} catch (e) {
			// Content is PLAIN TEXT: [OLDER FORMAT]
			// Handle the older format of notification data
			// If we cant parse the data, the data is still in the old format,
			// we just need to format the text in the correct field
			return <div className={additionalClassName}>{data}</div>;
		}
	}

	return null;
};

export default RichTextRenderer;
